<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">医生端功能权限配置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>医生姓名</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_name"
              style="width: 150px; margin-left: 10px"
              @change="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>医生手机</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_phone"
              style="width: 150px; margin-left: 10px"
              @change="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>医院</span>
            <el-input
              placeholder="请输入"
              v-model="hospital_name"
              style="width: 150px; margin-left: 10px"
              @change="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>地区</span>
            <el-cascader
              v-model="district"
              :options="goodsTypeData"
              placeholder="选择项目位置"
              :props="goodsTypeSet"
              style="width: 240px; margin-left: 10px"
              @change="search"
              clearable
            ></el-cascader>
          </div>

          <!-- <div class="item">
            <span>视频问诊</span>
            <div style="padding-top: 3px; margin-left: 10px">
              <el-radio-group
                v-model="is_video_consult"
                @change="search"
              >
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </div>
          </div> -->
          <div class="item">
            <span>分享开方</span>
            <div style="padding-top: 3px; margin-left: 10px">
              <el-radio-group
                v-model="is_pre_agr"
                @change="search"
              >
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="item">
            <span>拍照开方</span>
            <div style="padding-top: 3px; margin-left: 10px">
              <el-radio-group
                v-model="is_docpic"
                @change="search"
              >
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </div>
            <el-button
              type="primary"
              size="medium"
              style="margin-left: 10px"
              @click="search"
            >查询</el-button>
            <el-button
              size="medium"
              plain
              @click="clearSearch"
            >重置</el-button>
          </div>
        </div>
        <div style="text-align: right; margin-bottom: 10px">
          <el-button
            type="primary"
            size="medium"
            @click="setSearch"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('448') : false
            "
          >勾选设置</el-button>
          <el-button
            size="medium"
            plain
            style="margin-left: 10px"
            @click="setAll"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('448') : false
            "
          >全部设置</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleSelectionChangetable"
          >
            <el-table-column type="selection"></el-table-column>

            <el-table-column
              prop="user_name"
              label="医生头像"
              width="80"
            >
              <template slot-scope="scope">
                <div style="border: solid 1px #d3d3d3; width: 42px; height: 42px">
                  <img
                    :src="scope.row.head_img"
                    alt
                    style="width: 40px; height: 40px"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="doctor_name"
              label="医生信息"
            >
              <template slot-scope="scope">
                <div>
                  <span
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor:pointer"
                  >{{ scope.row.doctor_name }}</span>
                  <span
                    v-if="scope.row.sex == 1"
                    style="margin-left: 16px"
                  >男</span>
                  <span
                    v-if="scope.row.sex == 2"
                    style="margin-left: 16px"
                  >女</span>
                </div>
                <div>
                  <span>{{ scope.row.phone }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="department_name"
              label="科室"
            ></el-table-column>
            <el-table-column
              prop="hospital"
              label="医院"
            ></el-table-column>
            <el-table-column
              prop="address_str"
              label="地区"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="首次认证时间"
            ></el-table-column>
            <!-- 
            <el-table-column label="视频问诊">
              <template slot-scope="scope">
                <span>
                  <span v-if="scope.row.video_consult">开启</span>
                  <span v-else>关闭</span>
                  <el-switch
                    style="margin-left: 6px"
                    v-model="scope.row.video_consult"
                    active-color="#669961"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('448')
                        : false
                    "
                    @change="
                      (value) => {
                        return setVideo(value, scope.row.doctor_id);
                      }
                    "
                  ></el-switch>
                </span>
              </template>
            </el-table-column> -->

            <el-table-column label="分享开方">
              <template slot-scope="scope">
                <span>
                  <span v-if="scope.row.pre_agr">开启</span>
                  <span v-else>关闭</span>
                  <el-switch
                    style="margin-left: 6px"
                    v-model="scope.row.pre_agr"
                    active-color="#669961"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('448')
                        : false
                    "
                    @change="
                      (value) => {
                        return setShare(value, scope.row.doctor_id);
                      }
                    "
                  ></el-switch>
                </span>
              </template>
            </el-table-column>

            <el-table-column label="拍照开方">
              <template slot-scope="scope">
                <span>
                  <span v-if="scope.row.docpic">开启</span>
                  <span v-else>关闭</span>
                  <el-switch
                    style="margin-left: 6px"
                    v-model="scope.row.docpic"
                    active-color="#669961"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('448')
                        : false
                    "
                    @change="
                      (value) => {
                        return setPhoto(value, scope.row.doctor_id);
                      }
                    "
                  ></el-switch>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="坐班表">
              <template slot-scope="scope">
                <span>
                  <span v-if="scope.row.scheduling">开启</span>
                  <span v-else>关闭</span>
                  <el-switch
                    style="margin-left: 6px"
                    v-model="scope.row.scheduling"
                    active-color="#669961"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('448')
                        : false
                    "
                    @change="
                      (value) => {
                        return setSchedule(value, scope.row.doctor_id);
                      }
                    "
                  ></el-switch>
                </span>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="Schedule(scope.row.doctor_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('611')
                      : false
                  "
                >坐班设置</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 配置弹窗 -->
    <el-dialog
      title="选择配置的权限"
      :visible.sync="outdia"
      width="430px"
      style="text-align: left"
      :close-on-click-modal="false"
    >
      <el-dialog
        width="320px"
        :title="dialogtitle"
        :visible.sync="innerdia"
        append-to-body
      >
        <div style="text-align: center; padding: 10px 0 20px">
          <div style="margin-bottom: 20px">请确定将被选中医生设置权限为</div>
          <div>
            <el-radio-group v-model="open_type">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </div>
          <div style="margin-top: 16px">
            <el-button
              @click="innerdia = false"
              size="small"
            >取消</el-button>
            <el-button
              type="primary"
              @click="setLimit"
              size="small"
            >确 定</el-button>
          </div>
        </div>
      </el-dialog>
      <div style="text-align: center; padding: 20px 0">
        <el-radio-group
          v-model="type"
          @change="changetitle"
        >
          <!-- <el-radio :label="1">视频问诊</el-radio> -->
          <el-radio :label="2">分享开方</el-radio>
          <el-radio :label="3">拍照开方</el-radio>
          <el-radio :label="4">坐班表</el-radio>
        </el-radio-group>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="outdia = false"
          size="small"
        >取消</el-button>
        <el-button
          type="primary"
          @click="innerdia = true"
          size="small"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: '',
      doctor_phone: '',
      hospital_name: '',
      district: [],
      is_video_consult: '',
      is_docpic: '',
      is_pre_agr: '',
      goodsTypeData: [],
      goodsTypeSet: {
        value: 'value',
        label: 'label',
        children: 'children',
        checkStrictly: true
      },
      selection: [],
      searchAll: false, //是否设置全部
      outdia: false,
      innerdia: false,
      dialogtitle: '视频问诊',
      type: 1,
      open_type: 1,
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取医生列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        hospital_name: this.hospital_name,
        is_video_consult: this.is_video_consult,
        is_docpic: this.is_docpic,
        is_pre_agr: this.is_pre_agr,
        province_id: this.district[0],
        city_id: this.district[1],
        district_id: this.district[2]
      };
      this.axios.post('platform/doctor/doctorRoleList', data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            item.video_consult = item.is_video_consult == 1 ? true : false;
            item.docpic = item.is_docpic == 1 ? true : false;
            item.pre_agr = item.is_pre_agr == 1 ? true : false;
            item.scheduling = item.is_scheduling == 1 ? true : false;
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //多选
    handleSelectionChangetable(val) {
      this.selection = val.map((item) => {
        return item.doctor_id;
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    clearSearch() {
      this.doctor_phone = '';
      this.doctor_name = '';
      this.hospital_name = '';
      this.district = [];
      this.is_video_consult = '';
      this.is_docpic = '';
      this.is_video_consult = '';
      this.is_pre_agr = '';
      this.pagesize = 10;
      this.getList();
    },
    //获取地区信息
    getCityData() {
      this.axios
        .post('platform/platform/getProvinceCityDistrict')
        .then((res) => {
          if (res.code == 0) {
            let tree = res.data.list;
            this.transRegions(tree);
            this.goodsTypeData = tree;
          }
        });
    },
    transRegions(tree) {
      tree.forEach((item) => {
        if (item.city || item.district) {
          item.children = item.city || item.district;
          delete item.city;
          delete item.district;
          this.transRegions(item.children);
        }
        if (item.province_id) {
          item.value = item.province_id;
          delete item.province_id;
        }
        if (item.city_id) {
          item.value = item.city_id;
          delete item.city_id;
        }
        if (item.district_id) {
          item.value = item.district_id;
          delete item.district_id;
        }
        if (item.name) {
          item.label = item.name;
          delete item.name;
        }
      });
    },
    // //设置视频问诊
    // setVideo(value, doctor_ids) {
    //   let text = '';
    //   let data = {
    //     open_type: '',
    //     type: 1,
    //     doctor_ids: doctor_ids
    //   };
    //   if (value) {
    //     text = '确定开启权限吗？';
    //     data.open_type = 1;
    //   } else {
    //     text = '确定关闭权限吗？';
    //     data.open_type = 0;
    //   }
    //   this.$confirm(text, '视频问诊', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消'
    //   })
    //     .then(() => {
    //       this.axios
    //         .post('platform/doctor/updateDoctorTypeAuth', data)
    //         .then((res) => {
    //           if (res.code == 0) {
    //             this.$message.success('设置成功');
    //             this.getList();
    //           } else {
    //             this.getList();
    //           }
    //         })
    //         .catch(() => {
    //           this.getList();
    //         });
    //     })
    //     .catch(() => {
    //       this.getList();
    //     });
    // },
    //分享开方
    setShare(value, doctor_ids) {
      let text = '';
      let data = {
        open_type: '',
        type: 2,
        doctor_ids: doctor_ids
      };
      if (value) {
        text = '确定开启权限吗？';
        data.open_type = 1;
      } else {
        text = '确定关闭权限吗？';
        data.open_type = 0;
      }
      this.$confirm(text, '分享开方', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/doctor/updateDoctorTypeAuth', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('设置成功');
                this.getList();
              } else {
                this.getList();
              }
            })
            .catch(() => {
              this.getList();
            });
        })
        .catch(() => {
          this.getList();
        });
    },
    //拍照开方
    setPhoto(value, doctor_ids) {
      let text = '';
      let data = {
        open_type: '',
        type: 3,
        doctor_ids: doctor_ids
      };
      if (value) {
        text = '确定开启权限吗？';
        data.open_type = 1;
      } else {
        text = '确定关闭权限吗？';
        data.open_type = 0;
      }
      this.$confirm(text, '拍照开方', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/doctor/updateDoctorTypeAuth', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('设置成功');
                this.getList();
              } else {
                this.getList();
              }
            })
            .catch(() => {
              this.getList();
            });
        })
        .catch(() => {
          this.getList();
        });
    },
    //坐班表
    setSchedule(value, doctor_ids) {
      let text = '';
      let data = {
        open_type: '',
        type: 4,
        doctor_ids: doctor_ids
      };
      if (value) {
        text = '确定开启权限吗？';
        data.open_type = 1;
      } else {
        text = '确定关闭权限吗？';
        data.open_type = 0;
      }
      this.$confirm(text, '坐班表', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/doctor/updateDoctorTypeAuth', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('设置成功');
                this.getList();
              } else {
                this.getList();
              }
            })
            .catch(() => {
              this.getList();
            });
        })
        .catch(() => {
          this.getList();
        });
    },
    setSearch() {
      this.searchAll = false;
      if (!this.selection.length) {
        this.$message.error('请选择需要设置的医生');
        return false;
      }
      this.outdia = true;
      this.type = 1;
      this.open_type = 1;
    },
    setAll() {
      this.searchAll = true;
      this.outdia = true;
      this.type = 1;
      this.open_type = 1;
    },
    changetitle(value) {
      if (value == 1) {
        this.dialogtitle = '视频问诊';
      }
      if (value == 2) {
        this.dialogtitle = '分享开方';
      }
      if (value == 3) {
        this.dialogtitle = '拍照开方';
      }
      if (value == 4) {
        this.dialogtitle = '坐班表';
      }
    },
    //批量设置
    setLimit() {
      let data = {
        type: this.type,
        open_type: this.open_type
      };
      if (this.searchAll) {
        data.doctor_ids = 999;
      } else {
        data.doctor_ids = this.selection.toString();
      }
      this.axios
        .post('platform/doctor/updateDoctorTypeAuth', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('设置成功');
            this.outdia = false;
            this.innerdia = false;
            this.getList();
          } else {
            this.getList();
          }
        })
        .catch(() => {
          this.getList();
        });
    },
    //设置班表
    Schedule(doctor_id) {
      this.$router.push({ path: 'schedule', query: { doctor_id } });
    }
  },
  created() {
    this.getList();
    this.getCityData();
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 30px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
  }
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 300px;
  padding-top: 20px;
  margin-bottom: 20px;
}
</style>
